export enum CfarOption {
  PARTIAL_CASH_REFUND,
  AIRLINE_CREDIT,
}
